/** API adresi: VITE_API_URL (varsayılan yerel geliştirme). */
export const API_URL: string = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:4000';
